(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/statistics/assets/javascripts/use-participants.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/statistics/assets/javascripts/use-participants.js');
"use strict";


const {
  useContext,
  useEffect,
  useState
} = React;
const {
  PlayContext
} = svs.racing_game.components.playContext;
const useParticipants = navState => {
  const [participants, setParticipants] = useState([]);
  const [selectedParticipant, setSelectedParticipant] = useState(undefined);
  const {
    race
  } = useContext(PlayContext);
  useEffect(() => {
    if (race) {
      setParticipants(race.participants);
      const id = parseInt(navState.participantId, 10);
      const noParticipant = !selectedParticipant && race.participants;
      const refreshParticipant = selectedParticipant && selectedParticipant.participantId !== id;
      if (noParticipant || refreshParticipant) {
        setSelectedParticipant(race.participants.find(p => p.participantId === id));
      }
    }
  }, [race, navState.participantId]);
  return [participants, selectedParticipant];
};
svs.racing_game.components.statistics.useParticipants = useParticipants;

 })(window);